var Unit;
(function (Unit) {
    Unit["EM"] = "em";
    Unit["PERCENT"] = "%";
    Unit["PX"] = "px";
    Unit["REM"] = "rem";
    Unit["VH"] = "vh";
    Unit["VW"] = "vw";
})(Unit || (Unit = {}));
export { Unit, };
//# sourceMappingURL=unit.js.map